import React from "react";
import Modal from "react-bootstrap/Modal";
import { WheelSlot } from "../../types/wheel-of-luck";
import { RewardPresentation, rewardLevel } from "../../hooks/useWheelRewardCatalog";
import WheelButton from "./WheelButton";
import { useAppTranslation } from "../../i18n/useAppTranslation";

type Props = { open: boolean; reward: WheelSlot | null; presentation: RewardPresentation | null; onClose: () => void };
const assets = "/assets/images/wheel/events";

export default function WheelWinDialog({ open, reward, presentation, onClose }: Props) {
  const { t, currentLanguage } = useAppTranslation(["wheel"]);
  const level = reward ? rewardLevel(reward) : 0;
  const number = (value: number) => value.toLocaleString(currentLanguage);
  // "You won 3 × Big Jack level 6!": the reward's name goes inside the
  // translated sentence, so each language, right-to-left too, orders it.
  let prize = presentation?.name ?? "";
  if (level > 0) prize = t("wheel:rewardLevel", { reward: prize, level: number(level) });
  if (reward && reward.quantity > 1) prize = t("wheel:rewardQuantity", { reward: prize, quantity: number(reward.quantity) });
  return <Modal show={open && Boolean(reward)} onHide={onClose} centered backdrop="static" keyboard={false}
    aria-label={t("wheel:win.label")} dialogClassName="luck-win-modal" contentClassName="luck-win-content">
    {reward && presentation && <div className="luck-win-stage">
      <img className="luck-win-frame" src={`${assets}/win-frame.png`} alt="" />
      <img className="luck-win-ribbon" src={`${assets}/win-ribbon.png`} alt="" />
      <h2>{t("wheel:win.title")}</h2>
      <p className="luck-win-name">{t("wheel:win.youWon", { reward: prize })}</p>
      <img className="luck-win-burst" src={`${assets}/win-burst.png`} alt="" />
      <div className="luck-win-reward">
        <img className="luck-win-portrait-frame" src={`${assets}/reward-frame.png`} alt="" />
        {presentation.icon && <img className="luck-win-prize" src={presentation.icon} alt={presentation.name} />}
        {level > 0 && <span className="luck-win-level">{level}</span>}
      </div>
      <WheelButton claim onClick={onClose}>{t("wheel:win.claim")}</WheelButton>
    </div>}
  </Modal>;
}
